// defined by variables.scss
const breakpoints = {
  s: 421,
  m: 701,
  l: 1181,
  xl: 1481,
};

export default breakpoints;
